import { Box, Card, CardBody, Skeleton } from "@chakra-ui/react";

function LoadingSceneCard() {
  return (
    <Card
      direction="row"
      overflow="hidden"
      position="relative"
      transition="all 0.24s ease"
    >
      <Skeleton height="80px" width="80px" />
      <CardBody display="flex" gap="4" p={3} px={4} alignItems="center">
        <Box flex="1" display="flex" flexDir="column" gap={2} height="100%">
          <Skeleton height="3" width="80%" mb="2" />
          {Array.from(Array(2)).map((i, ind) => (
            // eslint-disable-next-line react/no-array-index-key
            <Box key={ind} display="flex" gap="1">
              <Skeleton height="2" width="3" />
              <Skeleton height="2" width="20" />
            </Box>
          ))}
        </Box>
        <Box
          display="flex"
          flexDirection="column"
          gap="2"
          flex="1"
          height="100%"
          justifyContent="center"
          alignItems="flex-end"
        >
          <Box
            display="flex"
            alignItems="center"
            flexDir="column"
            textAlign="center"
            width="100%"
            gap="2"
          >
            <Skeleton height="2" width="40%" />
            <Skeleton height="2" width="85%" />
          </Box>
        </Box>
      </CardBody>
    </Card>
  );
}

export default LoadingSceneCard;
